export const DISTANCE_OPTIONS = [
  { title: '10 Km', value: 10 },
  { title: '25 Km', value: 25 },
  { title: '50 Km', value: 50 },
  { title: '100 Km', value: 100 },
  { title: '250 Km', value: 250 },
];

export const SORT_OPTIONS = [
  { title: 'Most Recent', value: 'recent' },
  { title: 'Closest Location', value: 'distance' },
  { title: 'Job Title (A-Z)', value: 'title' },
];